import {
  EmptyState,
  EmptyStateContainer,
} from 'module/ui/components/atoms/empty-state';
import { FontAwesomeIcon } from 'module/ui/components/atoms/icon/icon';
import { faFolder } from '@fortawesome/pro-regular-svg-icons';
import { FormattedMessage } from 'react-intl';

type NoSearchResultProps = {
  onPrimaryAction: () => void;
};

export const NoSearchResult = ({ onPrimaryAction }: NoSearchResultProps) => {
  return (
    <EmptyStateContainer>
      <EmptyState
        image={
          <FontAwesomeIcon
            icon={faFolder}
            size={50}
            iconSize={40}
            color="transparent"
          />
        }
        title={
          <FormattedMessage id="knowledge_base.empty_state.no_search_results.title" />
        }
        message={
          <FormattedMessage id="knowledge_base.empty_state.no_search_results.message" />
        }
        primaryCTA={
          <EmptyState.CallToAction.Primary onClick={onPrimaryAction}>
            <FormattedMessage id="clear_search" />
          </EmptyState.CallToAction.Primary>
        }
      />
    </EmptyStateContainer>
  );
};
